<template>
  <div>
    <el-menu-item v-if="!item.arr && !item.hidden" :ref="item.index" :data="item.functionId" :title="item.title" :index="item.index">
      {{ item.title }}
    </el-menu-item>
    <template v-if="item.arr && !item.hidden">
      <el-submenu :index="item.index" popper-append-to-body>
        <template slot="title">
          {{ item.title }}
        </template>
        <template v-for="(arritem, arrindex) in item.arr">
          <leftNavItems :key="arrindex" :item="arritem"></leftNavItems>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
export default {
  name: "leftNavItems",
  data() {
    return {};
  },
  props: ["item"],
  mounted() { },
  methods: {},
};
</script>
